import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
    Button,
    ButtonVariant,
    IconPosition,
    Lightbox
} from '../../../../styles';

interface QuestionAssuranceProps {
    lienModale: string;
    titreModale: string;
    questionsPuces: React.JSX.Element;
    onOpenModalAnalytic: () => void;
}

export const QuestionAssuranceModal: React.FC<QuestionAssuranceProps> = ({
    lienModale,
    titreModale,
    questionsPuces,
    onOpenModalAnalytic
}) => {
    const [isModalOpened, setIsModalOpened] = useState<boolean>(false);
    const [t] = useTranslation('QuestionAssuranceModal');

    // Quand la modale ouvre, on envoie des analytiques
    const handleOpenModal = () => {
        setIsModalOpened(true);
        onOpenModalAnalytic();
    };

    return (
        <>
            <Button
                variant={ButtonVariant.tertiary}
                iconName="navigations_contour_modale"
                iconPosition={IconPosition.start}
                onClick={handleOpenModal}
                dataTestId="bouton_questionDetails"
            >
                {lienModale}
            </Button>
            <Lightbox
                show={isModalOpened}
                title={titreModale}
                buttonPrimaryLabel={t('buttonText')}
                onClickPrimaryButton={() => setIsModalOpened(false)}
                onClose={() => setIsModalOpened(false)}
                dataTestId={'questionDetails_lightbox'}
            >
                {questionsPuces}
            </Lightbox>
        </>
    );
};
